import { useDispatch } from "react-redux"
import { SputnikAPIBaseURL, fnAJAXOutcomeErrorCallback } from "./customShared"
import { fnAJAXFetch, fnAJAXFetchPromise } from "./helpers"
import { AJAXSettings, fnDictSetIndex, timestampWithMilliseconds } from "./shared"
import { useConsole } from "../components/common/console/Console"
import { AppDispatch } from "./redux/store"
import { DataTableParams } from "../components/common/datagrid/DataGrid"

/**
* The shape of an API server response.
*/
export type APIServerResponse = {
    finalstate?:{perc?:number
            errorlevel?:number
            status?:string
            other?:any
            error?:string
        }
    error?:string
    outcome?:boolean
    content?:any
    status?:number
    cookiesset?:string[]
  }
  
  /**
  * The shape of an AJAX outcome.
  */
  export type AJAXOutcome = {
    ajax_success:boolean
    ajax_value?:APIServerResponse
    ajax_status:number
    ajax_headers?:any
  } 

 
/**
 * Interface representing a ShuteMessage.
 * It has a mandatory 'eventname' property of type string and an optional 'data' property of type Record<string, any>.
 */
export interface ShuteMessage {
    eventname: string;
    data?: Record<string, any>;
  }
   
/**

Sends a Boston event message to the server.
@param ptOutcome - The outcome of the event.
@param ptEvent - The Shute message containing the event information.
              eventname: The name of the event associated with the message.
              data: An optional dictionary representing data associated with the message.

Note: Include 'eventname' to ensure routing to the intended recipient,
and 'session' to link to an existing web server session if known.
*/
export async function fnPushBostonEvent(
    ptEvent:ShuteMessage,
    dispatch:any) {
  var bSuccess:boolean = false
  var oValue:any=null
  // console.log('send to api',ptEvent)
  var tAJAXSettings:AJAXSettings = {
        method: "PUT",
        url: `${SputnikAPIBaseURL}api/securepush`,
        returnContentType: "json",
        data: {ptEvent},
        mode:"cors",
        credentials: "include",
        outcome_callback: function (success: boolean, status: number, value: any, headers: any ) {
          console.log(success,status,value,headers)
          bSuccess=success
          oValue=value
        },
        dispatch:dispatch
      }

  await fnAJAXFetch(tAJAXSettings)

  return { success: bSuccess, data: oValue };
};


export function fnValidAPIResponse(ptReturn:APIServerResponse): boolean {
  if (ptReturn.finalstate?.error) {
    if (ptReturn.outcome) {
      // an error was sent, but outcome was still true
      return true
    };
    return false
  };
  return true
}

export function fnValidAJAXOutcome(ptReturn:AJAXOutcome): boolean {
  if (ptReturn.ajax_success) {
      return true
  } else {
   return fnAJAXOutcomeErrorCallback(ptReturn);
  };
};



export async function fnReadUserPrefs(piUserID:number,psUserAttributesKeyAddress:string,dispatch:any): Promise<{ success: boolean; data: any }> {
  var bSuccess:boolean = false
  var oValue:any=null
  var tServerCallParams: {} = { userid:piUserID,userattributekeyaddress: psUserAttributesKeyAddress.substring(1)};
  var tAJAXSettings:AJAXSettings = {
        method: "PUT",
        url: `${SputnikAPIBaseURL}api/readprefs`,
        data: tServerCallParams,
        mode:"cors",
        credentials: "include",
        outcome_callback: function (success: boolean, status: number, value: any, headers: any ) {
          bSuccess=success
          oValue=value
        },
        dispatch:dispatch
      }

  await fnAJAXFetch(tAJAXSettings)
  // console.log("Current user prefs value from db", oValue )
  return { success: bSuccess, data: oValue };
};

export async function fnSavePreferences(getState: Function, dispatch: any): Promise<{ success: boolean; data: any }> {
  var bSuccess:boolean = false
  var oValue:any=null  
  const updateQueue = getState().prefs.updateQueue;
  console.log(updateQueue)
  if (!updateQueue || !updateQueue.length) {return { success: true, data: null };}
  var tServerCallParams = {'saveprefs':updateQueue}
  console.log(tServerCallParams)
  var tAJAXSettings:AJAXSettings = {
        method: "PUT",
        url: `${SputnikAPIBaseURL}api/saveprefs`,
        data: tServerCallParams,
        mode:"cors",
        credentials: "include",
        outcome_callback: function (success: boolean, status: number, value: any, headers: any ) {
          bSuccess=success
          oValue=value
        },
        dispatch:dispatch
      }
    // console.log(tServerCallParams)
  await fnAJAXFetch(tAJAXSettings)
  return { success: bSuccess, data: oValue };
};


export async function fnPullSessionLogs(plLastID:number,plPageLen:number,
  dispatch:any): Promise<{data:any}> {
  var tLogs:any
  var tParams: {} = {lastid:plLastID,pagelen:plPageLen};
  var tAJAXSettings:AJAXSettings = {
          method: "GET",
          url: `${SputnikAPIBaseURL}api/pullsessionlogs`,
          returnContentType: "json",
          // contentType: "application/json",
          data: tParams,
          outcome_callback: function (success: boolean, status: number, value: any, headers: any ) {
            tLogs = {data:value}
          },
          dispatch:dispatch
        }
  await fnAJAXFetch(tAJAXSettings)

  return tLogs
};


export async function fnPullAdminEvents(ptSearchParams: {},dispatch:any): Promise<{ success: boolean; data: any }> {
  var bSuccess:boolean = false
  var oValue:any=null
  // console.log(ptSearchParams)
  var tAJAXSettings:AJAXSettings = {
        method: "PUT",
        url: `${SputnikAPIBaseURL}api/pulladminevents`,
        returnContentType: "json",
        data: ptSearchParams,
        mode:"cors",
        credentials: "include",
        outcome_callback: function (success: boolean, status: number, value: any, headers: any ) {
          bSuccess=success
          oValue=value
        },
        dispatch:dispatch
      }

  await fnAJAXFetch(tAJAXSettings)

  return { success: bSuccess, data: oValue };
};


export async function fnPullSweepFindings(dispatch:any, state: string = 'all'): Promise<{ success: boolean; data: any }> {
  var bSuccess:boolean = false
  var oValue:any=null
  var tAJAXSettings:AJAXSettings = {
        method: "PUT",
        url: `${SputnikAPIBaseURL}api/pullsweepfindings`,
        returnContentType: "json",
        data: { state },
        mode:"cors",
        credentials: "include",
        outcome_callback: function (success: boolean, status: number, value: any, headers: any ) {
          bSuccess=success
          oValue=value
        },
        dispatch:dispatch
      }

  await fnAJAXFetch(tAJAXSettings)

  if (!bSuccess || !oValue?.content) {
    return { success: false, data: null };
  }

  // content is [{key:'sweep.findings', value:[[row], [row], ...]}]
  const findingsEntry = oValue.content.find((e: any) => e.key === 'sweep.findings');
  if (!findingsEntry?.value) {
    return { success: true, data: [] };
  }

  // Map positional arrays to named objects
  // Cols: [findingid, finding_type, eventdate, host, object, detail, resolved_by, resolved]
  const findings = findingsEntry.value.map((row: any[]) => ({
    findingid: row[0],
    finding_type: row[1],
    eventdate: row[2],
    host: row[3],
    object: row[4],
    detail: row[5] ? (typeof row[5] === 'string' ? JSON.parse(row[5]) : row[5]) : null,
    resolved_by: row[6] || null,
    resolved: row[7] || null,
  }));

  return { success: true, data: findings };
};


export async function fnPullSweepRuns(dispatch: any, limit: number = 50): Promise<{ success: boolean; data: any }> {
  var bSuccess: boolean = false
  var oValue: any = null
  var tAJAXSettings: AJAXSettings = {
    method: "PUT",
    url: `${SputnikAPIBaseURL}api/pullsweepruns`,
    returnContentType: "json",
    data: { limit },
    mode: "cors",
    credentials: "include",
    outcome_callback: function (success: boolean, status: number, value: any, headers: any) {
      bSuccess = success
      oValue = value
    },
    dispatch: dispatch
  }

  await fnAJAXFetch(tAJAXSettings)

  if (!bSuccess || !oValue?.content) {
    return { success: false, data: null };
  }

  const runsEntry = oValue.content.find((e: any) => e.key === 'sweep.runs');
  if (!runsEntry?.value) {
    return { success: true, data: [] };
  }

  // Map positional arrays: [admineventid, host, eventdate, report]
  const runs = runsEntry.value.map((row: any[]) => ({
    eventid: row[0],
    host: row[1],
    eventdate: row[2],
    report: typeof row[3] === 'string' ? JSON.parse(row[3]) : row[3],
  }));

  return { success: true, data: runs };
}

export async function fnPostSweepAction(
  action: string, findingType: string, object: string, host: string,
  extra: Record<string, any> = {}, dispatch: any
): Promise<{ success: boolean; data: any }> {
  var bSuccess: boolean = false
  var oValue: any = null
  var tAJAXSettings: AJAXSettings = {
    method: "PUT",
    url: `${SputnikAPIBaseURL}api/postsweepaction`,
    returnContentType: "json",
    data: { action, finding_type: findingType, object, host, extra },
    mode: "cors",
    credentials: "include",
    outcome_callback: function (success: boolean, status: number, value: any, headers: any) {
      bSuccess = success
      oValue = value
    },
    dispatch: dispatch
  }

  await fnAJAXFetch(tAJAXSettings)

  if (!bSuccess || !oValue?.content) {
    return { success: false, data: null };
  }

  const actionEntry = oValue.content.find((e: any) => e.key === 'sweep.action');
  return { success: true, data: actionEntry?.value || null };
}

export async function fnArchiveAdminEvents(ptSearchParams: any,dispatch:any): Promise<{ success: boolean; data: any }> {
  var bSuccess:boolean = false
  var oValue:any=null
  ptSearchParams['archiveevents']=true
  var tAJAXSettings:AJAXSettings = {
        method: "PUT",
        url: `${SputnikAPIBaseURL}api/pulladminevents/archive`,
        returnContentType: "json",
        data: ptSearchParams,
        mode:"cors",
        credentials: "include",
        outcome_callback: function (success: boolean, status: number, value: any, headers: any ) {
          bSuccess=success
          oValue=value
        },
        dispatch:dispatch
      }

  await fnAJAXFetch(tAJAXSettings)

  return { success: bSuccess, data: oValue };
};


export async function getTrendMetricData(ptMetricTags:string[],psAverageTrendType:string='',dispatch:any): Promise<{ success: boolean; data: any }> {
  var bSuccess:boolean = false
  var oValue:any=null
  const tSearchParams = {metricTags:ptMetricTags,averageType:psAverageTrendType}
  var tAJAXSettings:AJAXSettings = {
        method: "PUT",
        url: `${SputnikAPIBaseURL}api/pulltrenddata`,
        returnContentType: "json",
        data: tSearchParams,
        mode:"cors",
        credentials: "include",
        outcome_callback: function (success: boolean, status: number, value: any, headers: any ) {
          bSuccess=success
          oValue=value
        },
        dispatch:dispatch
      }

  await fnAJAXFetch(tAJAXSettings)

  return { success: bSuccess, data: oValue };
};

/**
 * Asynchronously cancels a session using the specified progress ID and optional session state items.
 *
 * This function sends a PUT request to the SputnikAPI's "cancelsession" endpoint to cancel a session.
 * The response from the server is processed, and the outcome_callback function is invoked to handle the result.
 *
 * @param plProgressID - The progress ID of the session to be canceled.
 * @param dispatch - The dispatch function used to update the application state with the response data.
 * @param ptSessionStateItems - (Optional) An object containing session state items to be sent with the request.
 * @returns A Promise that resolves to an object containing the success status and data from the server response.
 *          - success: A boolean indicating whether the session cancellation was successful.
 *          - data: The data returned from the server response. It may contain additional details about the cancellation.
 *
 * @throws Any error that occurs during the network request or response processing.
 *
 * @example
 * // Example usage:
 * const progressID = 12345;
 * const sessionStateItems = { key: 'value' };
 * try {
 *   const result = await fnCancelSession(progressID, dispatch, sessionStateItems);
 *   console.log(result.success); // true if the cancellation was successful, false otherwise.
 *   console.log(result.data);    // The data returned from the server response.
 * } catch (error) {
 *   console.error('Error cancelling session:', error);
 * }
 */
export async function fnCancelSession(plProgressID: number, dispatch: any, ptSessionStateItems?: {}): Promise<{ success: boolean; data: any }> {
  console.log("Cancelling session")
  var bSuccess:boolean = false
  var oValue:any=null
  var tAJAXSettings:AJAXSettings = {
        method: "PUT",
        url: `${SputnikAPIBaseURL}api/cancelsession`,
        returnContentType: "json",
        data: { progressid: plProgressID, stateitems: ptSessionStateItems},
        mode:"cors",
        credentials: "include",
        outcome_callback: function (success: boolean, status: number, value: any, headers: any ) {
          bSuccess=success
          oValue=value
        },
        dispatch:dispatch
      }

  await fnAJAXFetch(tAJAXSettings)

  return { success: bSuccess, data: oValue };
};

interface SearchParams {
  sourcetable: string;
  sessionkey:number;
  eventtypeid?: string;
  dt_search_start?: string;
  dt_search_end?: string;
  select_events_filter?: string[];
  archiveevents?: boolean;
}

export interface SputnikDataGridParams {
  searchparams: SearchParams;
  dtparams?: DataTableParams;
}


/**
 * Retrieves page settings from the server.  asynchronous function that sends a PUT request to the 'api/pullpagesettings' endpoint.
 *
 * @param {string|string[]} psPageSetting - The page setting or settings to be used in the request.
 * @param {any} dispatch - The function to dispatch the outcome of the AJAX request.
 * @return {Promise<{ success: boolean; data: any }>} - A Promise that resolves to an object containing a success status and response data.
 */
export async function fnAdmin_PullPageSettings(psPageSetting:string|string[],dispatch: AppDispatch,ptOtherParams:object={}): Promise<{ success: boolean; data: any }> {
  const { fnConsoleError } = useConsole();
  var bSuccess:boolean = false
  var oValue:any=null
  var tAJAXSettings:AJAXSettings = {
    method: "PUT",
    url: `api/pullpagesettings/preloaddata/${psPageSetting}`,
    returnContentType: "json",
    data: ptOtherParams,
    mode:"cors",
    credentials: "include",
    outcome_callback: function (success: boolean, status: number, value: any, headers: any ) {
      try {
        // console.log(value)
        bSuccess=success
        oValue=value.content.data
      } catch (oErr) {
        fnConsoleError(dispatch,dispatch,oErr)
        bSuccess=false
        oValue=undefined     
      };
         },
    dispatch:dispatch    

  }
  // console.log(tAJAXSettings)
  await fnAJAXFetch(tAJAXSettings)
  return { success: bSuccess, data: oValue };
};

/**
 * Powers a moron-relay-backed host on/off, or (for the subset with a *_cmd
 * GPIO pin wired -- see moronpower_hosts.json's cmd_hosts) sends a
 * restart/shutdown pulse (Tycho Infrastructure dashboard's HostCard
 * power/reboot/shutdown buttons). NOTE: reboot/shutdown pulses reach the
 * target Pi but its listener.py is still a logged dry run as of writing --
 * see sputnik's moronpower_client.py module docstring.
 *
 * @param {string} psHostKey - infra host key (e.g. "forge", "drogher").
 * @param {"on"|"off"|"restart"|"shutdown"} psAction - action to perform.
 * @param {any} dispatch - the function to dispatch the outcome of the AJAX request.
 * @return {Promise<{ success: boolean; data: any }>} - data.state is the relay's resulting "on"/"off" state (on/off actions only) on success.
 */
export async function fnAdmin_InfraPower(psHostKey:string,psAction:"on"|"off"|"restart"|"shutdown",dispatch: AppDispatch): Promise<{ success: boolean; data: any }> {
  const { fnConsoleError } = useConsole();
  var bSuccess:boolean = false
  var oValue:any=null
  var tAJAXSettings:AJAXSettings = {
    method: "POST",
    url: `api/infra/${psHostKey}/power/${psAction}`,
    returnContentType: "json",
    data: {},
    mode:"cors",
    credentials: "include",
    outcome_callback: function (success: boolean, status: number, value: any, headers: any ) {
      try {
        bSuccess = success && value?.outcome !== false
        oValue = value.content
      } catch (oErr) {
        fnConsoleError(dispatch,dispatch,oErr)
        bSuccess=false
        oValue=undefined
      };
    },
    dispatch:dispatch

  }
  await fnAJAXFetch(tAJAXSettings)
  return { success: bSuccess, data: oValue };
};

/**
 * Lists every vivo secrets SOT mirror file present on sputnik's local disk
 * (Tycho System > Secrets tab's file list -- {env, host, filename} per file).
 *
 * @param {any} dispatch - the function to dispatch the outcome of the AJAX request.
 * @return {Promise<{ success: boolean; data: any }>} - data.files is the file list.
 */
export async function fnAdmin_SecretsListFiles(dispatch: AppDispatch): Promise<{ success: boolean; data: any }> {
  const { fnConsoleError } = useConsole();
  var bSuccess:boolean = false
  var oValue:any=null
  var tAJAXSettings:AJAXSettings = {
    method: "GET",
    url: `api/secretsadmin/files`,
    returnContentType: "json",
    data: {},
    mode:"cors",
    credentials: "include",
    outcome_callback: function (success: boolean, status: number, value: any, headers: any ) {
      try {
        bSuccess = success && value?.outcome !== false
        oValue = value.content
      } catch (oErr) {
        fnConsoleError(dispatch,dispatch,oErr)
        bSuccess=false
        oValue=undefined
      };
    },
    dispatch:dispatch

  }
  await fnAJAXFetch(tAJAXSettings)
  return { success: bSuccess, data: oValue };
};

/**
 * Reads the full parsed content (values included) of one secrets mirror
 * file (Tycho System > Secrets tab, on selecting a file from the list).
 *
 * @param {string} psEnv - "prod" or "trunk".
 * @param {string} psHost - infra host key (e.g. "ironclad", "forge").
 * @param {any} dispatch - the function to dispatch the outcome of the AJAX request.
 * @return {Promise<{ success: boolean; data: any }>} - data.content is the parsed secrets object.
 */
export async function fnAdmin_SecretsGetFile(psEnv:string,psHost:string,dispatch: AppDispatch): Promise<{ success: boolean; data: any }> {
  const { fnConsoleError } = useConsole();
  var bSuccess:boolean = false
  var oValue:any=null
  var tAJAXSettings:AJAXSettings = {
    method: "GET",
    url: `api/secretsadmin/file/${psEnv}/${psHost}`,
    returnContentType: "json",
    data: {},
    mode:"cors",
    credentials: "include",
    outcome_callback: function (success: boolean, status: number, value: any, headers: any ) {
      try {
        bSuccess = success && value?.outcome !== false
        oValue = value.content
      } catch (oErr) {
        fnConsoleError(dispatch,dispatch,oErr)
        bSuccess=false
        oValue=undefined
      };
    },
    dispatch:dispatch

  }
  await fnAJAXFetch(tAJAXSettings)
  return { success: bSuccess, data: oValue };
};

/**
 * Sets one dot-path key in a secrets mirror file (squirrel-cli.py set),
 * then scp's the file back to ironclad's source of truth (Tycho System >
 * Secrets tab's inline editor, after the user confirms the overwrite).
 *
 * @param {string} psEnv - "prod" or "trunk".
 * @param {string} psHost - infra host key (e.g. "ironclad", "forge").
 * @param {string} psPath - dot-separated key path (e.g. "mariadb.drogher.pw").
 * @param {string} psValue - new plaintext value.
 * @param {any} dispatch - the function to dispatch the outcome of the AJAX request.
 * @return {Promise<{ success: boolean; data: any }>} - data.status is "updated" or "unchanged".
 */
export async function fnAdmin_SecretsSetKey(psEnv:string,psHost:string,psPath:string,psValue:string,dispatch: AppDispatch): Promise<{ success: boolean; data: any }> {
  const { fnConsoleError } = useConsole();
  var bSuccess:boolean = false
  var oValue:any=null
  var tAJAXSettings:AJAXSettings = {
    method: "PUT",
    url: `api/secretsadmin/file/${psEnv}/${psHost}/key`,
    returnContentType: "json",
    data: {path:psPath,value:psValue},
    mode:"cors",
    credentials: "include",
    outcome_callback: function (success: boolean, status: number, value: any, headers: any ) {
      try {
        bSuccess = success && value?.outcome !== false
        oValue = value.content
      } catch (oErr) {
        fnConsoleError(dispatch,dispatch,oErr)
        bSuccess=false
        oValue=undefined
      };
    },
    dispatch:dispatch

  }
  await fnAJAXFetch(tAJAXSettings)
  return { success: bSuccess, data: oValue };
};

export async function fnPullAdminEventID(ptSearchParams: {eventid: any, searchparams?: { sourcetable: string }},dispatch:any): Promise<{ success: boolean; data: any }> {
  var bSuccess:boolean = false
  var oValue:any=null
  var tAJAXSettings:AJAXSettings = {
        method: "PUT",
        url: `${SputnikAPIBaseURL}api/pulladminevents/eventid`,
        returnContentType: "json",
        data: ptSearchParams,
        mode:"cors",
        credentials: "include",
        outcome_callback: function (success: boolean, status: number, value: any, headers: any ) {
          bSuccess=success
          oValue=value
        },
        dispatch:dispatch
      }

  await fnAJAXFetch(tAJAXSettings)

  return { success: bSuccess, data: oValue };
};


export async function fnCancelAdminDataPopulation(ptSearchParams: {cancelInsert?: any, searchparams?: { sourcetable: string }},dispatch:any): Promise<{ success: boolean; data: any }> {
  var bSuccess:boolean = false
  var oValue:any=null
  ptSearchParams.cancelInsert=true
  var tAJAXSettings:AJAXSettings = {
        method: "PUT",
        url: `${SputnikAPIBaseURL}api/pulladminevents/cancelInsert`,
        returnContentType: "json",
        data: ptSearchParams,
        mode:"cors",
        credentials: "include",
        outcome_callback: function (success: boolean, status: number, value: any, headers: any ) {
          bSuccess=success
          oValue=value
        },
        dispatch:dispatch
      }

  await fnAJAXFetch(tAJAXSettings)

  return { success: bSuccess, data: oValue };
};
export async function fnPullLastImageByDevice(deviceName:string,dispatch:any): Promise<{ success: boolean; data: any }> {
  var bSuccess:boolean = false
  var oValue:any=null
  var tMediaParams:object = {type: "lastimage", camera: deviceName};
  var tAJAXSettings:AJAXSettings = {
        method: "PUT",
        url: `${SputnikAPIBaseURL}api/mediameta/lastimage`,
        returnContentType: "json",
        data: tMediaParams,
        mode:"cors",
        credentials: "include",
        outcome_callback: function (success: boolean, status: number, value: any, headers: any ) {
          bSuccess=success
          oValue=value
        },
        dispatch:dispatch
      }

  await fnAJAXFetch(tAJAXSettings)

  return { success: bSuccess, data: oValue };
};

export async function fnPullSessionMediaMeta(mediaID:number,dispatch:any): Promise<{ success: boolean; data: any }> {
  var bSuccess:boolean = false
  var oValue:any=null
  var tMediaParams:object = {type: "singlefile", id: mediaID};
  var tAJAXSettings:AJAXSettings = {
        method: "PUT",
        url: `${SputnikAPIBaseURL}api/mediameta/singlefile`,
        returnContentType: "json",
        data: tMediaParams,
        mode:"cors",
        credentials: "include",
        outcome_callback: function (success: boolean, status: number, value: any, headers: any ) {
          bSuccess=success
          oValue=value
        },
        dispatch:dispatch
      }

  await fnAJAXFetch(tAJAXSettings)

  return { success: bSuccess, data: oValue };
};

export async function fnPullMediaImageSource(mediaID:number,dispatch:any): Promise<{ success: boolean; data: any }> {
  var bSuccess:boolean = false
  var oValue:any=null
  var tMediaParams:object = { id: mediaID};
  var tAJAXSettings:AJAXSettings = {
        method: "PUT",
        url: `${SputnikAPIBaseURL}api/mediasource`,
        returnContentType: "json",
        data: tMediaParams,
        mode:"cors",
        credentials: "include",
        outcome_callback: function (success: boolean, status: number, value: any, headers: any ) {
          bSuccess=success
          oValue=value
        },
        dispatch:dispatch
      }

  await fnAJAXFetch(tAJAXSettings)

  return { success: bSuccess, data: oValue };
};


export async function fnPullAdminHistory(hxtype:string,dispatch:any): Promise<{ success: boolean; data: any }> {
  var bSuccess:boolean = false
  var oValue:any=null
  var tMediaParams:object = {hxtype: hxtype};
  var tAJAXSettings:AJAXSettings = {
        method: "PUT",
        url: `${SputnikAPIBaseURL}api/getservicehistory/${hxtype}`,
        returnContentType: "json",
        data: tMediaParams,
        mode:"cors",
        credentials: "include",
        outcome_callback: function (success: boolean, status: number, value: any, headers: any ) {
          bSuccess=success
          oValue=value
        },
        dispatch:dispatch
      }

  await fnAJAXFetch(tAJAXSettings)

  return { success: bSuccess, data: oValue };
};


export async function fnPullAdminHistoryByKey(hxtype:string,key:string,dispatch:any): Promise<{ success: boolean; data: any }> {
  console.log('fnPullAdminHistoryByKey')
  var bSuccess:boolean = false
  var oValue:any=null
  var tMediaParams:object = {hxtype: hxtype,key:key};
  var tAJAXSettings:AJAXSettings = {
        method: "PUT",
        url: `${SputnikAPIBaseURL}api/getservicehistory/${hxtype}/${key}`,
        returnContentType: "json",
        data: tMediaParams,
        mode:"cors",
        credentials: "include",
        outcome_callback: function (success: boolean, status: number, value: any, headers: any ) {
          bSuccess=success
          oValue=value
        },
        dispatch:dispatch
      }

  await fnAJAXFetch(tAJAXSettings)

  return { success: bSuccess, data: oValue };
};


// export async function fnCallJavelinAPI(method:"GET" | "PUT" | "POST" | "DELETE" | undefined,url:string,tParams:object,dispatch:any): Promise<{ success: boolean, value: any }> {
//   var bSuccess:boolean = false
//   var oValue:any=null
//   try {
//     var tAJAXSettings:AJAXSettings = {
//       method: method,
//       url: `${SputnikAPIBaseURL}api/javelin/${url}`,
//       returnContentType: "json",
//       data: tParams,
//       mode:"cors",
//       credentials: "include",
//       outcome_callback: function (success: boolean, status: number, value: any, headers: any,callerID: any ) {
//         console.log(success, status, value, headers,callerID)
//         if (tAJAXSettings.callerID && callerID!==tAJAXSettings.callerID) {
//           console.log(`got a reponse for the wrong callerID: ${callerID}!==${tAJAXSettings.callerID}`)
//         }
//         bSuccess=success
//         oValue=value
//       },
//       dispatch:dispatch,
//       callerID:url
//     }
//     console.log(`fnCallJavelinAPI - Starting call to ${url}`)
//     await fnAJAXFetch(tAJAXSettings)
//     console.log(`fnCallJavelinAPI - Finished call to ${url}`)
//     // console.log(oValue)
//     if (bSuccess) {
//       console.log(oValue)
//     } else {
//         throw new Error(`Server response was false: ${JSON.stringify(oValue)}`); 
//     }    

//     return { success: bSuccess, value: oValue };
//   } catch (error) {
//     console.error(error)
//     return { success: false, value: null };
//   }


// };


export async function fnCallJavelinAPI(method:"GET" | "PUT" | "POST" | "DELETE" | undefined
    ,url:string
    ,tParams:object
    ,dispatch:any): Promise<{ success: boolean, value: any }> 
  {
  try {
    fnDictSetIndex(tParams,'tagid',timestampWithMilliseconds())
    var tAJAXSettings:AJAXSettings = {
      method: method,
      url: `${SputnikAPIBaseURL}api/javelin/${url}`,
      returnContentType: "json",
      data: tParams,
      mode:"cors",
      credentials: "include",
      dispatch:dispatch,
      callerID:url
    }
    console.log(`fnCallJavelinAPI - Starting call to ${url}`)
    const response = await fnAJAXFetchPromise(tAJAXSettings)
    console.log(`fnCallJavelinAPI - Finished call to ${url}`)
    console.log(`Response from ${url}: `, response);

    if (response.success) {
      return { success: true, value: response.data };
    } else {
      throw new Error(`Server response was false: ${JSON.stringify(response.data)}`);
    }
  } catch (error) {
    return { success: false, value: error };
  }
}

export async function fnCortexExplainRule(requestId: string, rule: object, dispatch: any): Promise<{ success: boolean, value: any }> {
  try {
    var tAJAXSettings: AJAXSettings = {
      method: "POST",
      url: `${SputnikAPIBaseURL}api/cortex/explainrule`,
      returnContentType: "json",
      data: { ...rule, request_id: requestId },
      mode: "cors",
      credentials: "include",
      dispatch: dispatch,
      callerID: requestId
    }
    const response = await fnAJAXFetchPromise(tAJAXSettings)
    if (response.success) {
      return { success: true, value: response.data };
    } else {
      throw new Error(`Server response was false: ${JSON.stringify(response.data)}`);
    }
  } catch (error) {
    return { success: false, value: error };
  }
}

export async function fnCortexRegenerate(requestId: string, viewType: string, dispatch: any): Promise<{ success: boolean, value: any }> {
  try {
    var tAJAXSettings: AJAXSettings = {
      method: "POST",
      url: `${SputnikAPIBaseURL}api/cortex/regenerate`,
      returnContentType: "json",
      data: { view_type: viewType, request_id: requestId },
      mode: "cors",
      credentials: "include",
      dispatch: dispatch,
      callerID: requestId
    }
    const response = await fnAJAXFetchPromise(tAJAXSettings)
    if (response.success) {
      return { success: true, value: response.data };
    } else {
      throw new Error(`Server response was false: ${JSON.stringify(response.data)}`);
    }
  } catch (error) {
    return { success: false, value: error };
  }
}
